const ReviewRating = ({ register, ratingValue }) => {
  return (
    <div className="address_head_block d-flex">
      <div className="rate_item">
        <h6>Rate this product</h6>
        <div className="give_rate_star">
          <div className="give_item_rating">
            <label>
              <input
                {...register('rating', { required: true })}
                type="radio"
                value={1}
              />
              <span className="icon">★</span>
            </label>
            <label>
              <input
                {...register('rating', { required: true })}
                type="radio"
                value={2}
              />
              <span className="icon">★</span>
              <span className="icon">★</span>
            </label>
            <label>
              <input
                {...register('rating', { required: true })}
                type="radio"
                value={3}
              />
              <span className="icon">★</span>
              <span className="icon">★</span>
              <span className="icon">★</span>
            </label>
            <label>
              <input
                {...register('rating', { required: true })}
                type="radio"
                value={4}
              />
              <span className="icon">★</span>
              <span className="icon">★</span>
              <span className="icon">★</span>
              <span className="icon">★</span>
            </label>
            <label>
              <input
                {...register('rating', { required: true })}
                type="radio"
                value={5}
              />
              <span className="icon">★</span>
              <span className="icon">★</span>
              <span className="icon">★</span>
              <span className="icon">★</span>
              <span className="icon">★</span>
            </label>
          </div>
          {/*<button type="button" class="give_rating_btn"><i class="fas fa-star"></i></button>
                                      <button type="button" class="give_rating_btn"><i class="fas fa-star"></i></button>
                                      <button type="button" class="give_rating_btn"><i class="fas fa-star"></i></button>
                                      <button type="button" class="give_rating_btn"><i class="fas fa-star"></i></button>
                                      <button type="button" class=""><i class="fas fa-star"></i></button> */}
        </div>
      </div>
      <div className="rating_count">
        overall Rating<span>{ratingValue}.0</span>
      </div>
    </div>
  );
};

export default ReviewRating;
